import { formatToCurrency } from "shared/utils";

export const NonCaliforniaRows = ({
  applicationFeeAmount
}: {
  applicationFeeAmount: number;
}) => (
  <tr className="text-xxs text-content-1000 font-medium">
    <td className="py-1 px-2">BoomScreen Application</td>
    <td className="text-right">1</td>
    <td className="text-right">
      {formatToCurrency({ cents: applicationFeeAmount, currency: "USD" })}
    </td>
    <td className="text-right">
      {formatToCurrency({ cents: applicationFeeAmount, currency: "USD" })}
    </td>
  </tr>
);
